import { traceHandle } from '../tracing'
import { withGlobalOptions } from '../types'
import { fetchClubConfig } from './fetchClubConfig'
import { fetchTierDefinitions } from './fetchTierDefinitions'

const metaObjectAttributes = {
  'shopify.api': 'storefront',
  'shopify.operation': 'metaobject',
} as const

export const metaObjectHandles = withGlobalOptions({
  fetchTierDefinitions: traceHandle(
    'shopify.storefront.metaobject.query',
    metaObjectAttributes,
    fetchTierDefinitions,
  ),
  fetchClubConfig: traceHandle(
    'shopify.storefront.metaobject.query',
    metaObjectAttributes,
    fetchClubConfig,
  ),
})
